import styled from 'styled-components';
import { BADI_COLORS, unitizedPx } from '@badi/badi-components';

export const Root = styled.div`
  border: 1px solid ${BADI_COLORS.NEUTRAL.NEUTRAL_10};
  border-radius: 4px;
  padding: ${unitizedPx(3)};
  margin: 0px ${unitizedPx(3)};
`;
